import React from 'react';
let psl = require('psl');

class ContentSection extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() { }

    extractHostname(url) {
        var hostname;
        //find & remove protocol (http, ftp, etc.) and get hostname

        if (url.indexOf("//") > -1) {
            hostname = url.split('/')[2];
        }
        else {
            hostname = url.split('/')[0];
        }

        //find & remove port number
        hostname = hostname.split(':')[0];
        //find & remove "?"
        hostname = hostname.split('?')[0];

        return hostname;
    }


    render() {
        if (!Object.keys(this.props.page_data).length) return <section className="section" />;
        let sectionData = this.props.page_data.acf ? this.props.page_data.acf.content : [];
        let rightContent = '';
        let _this = this;
        switch (Number(sectionData.type)) {
            case 1:
                rightContent = `<figure><img src=${sectionData.image.url} alt=${sectionData.image.alt} title=${sectionData.image.title}/></figure>`;
                break;
            case 2:
                let url = sectionData.video;
                let domain = psl.get(_this.extractHostname(url));
                let html = null;
                switch (domain) {
                    case 'youtube.com':
                        html = `<iframe src="${url}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
                        break;
                    case 'vimeo.com':
                        html = `<iframe src="${url}?loop=1" style="position:absolute; top:0; left:0; width:100%; height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                        <script src="https://player.vimeo.com/api/player.js"></script>`;
                        break;
                    default:
                        html = `<iframe src="${url}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
                        break;
                }
                rightContent = `<div class="embeded-vdo-container" >${html}</div>`;
                break;

        }

        return (
            <section className="section">
                <div className="main-container">
                    <section className="layout layout-1">
                        <div className="contentArea">
                            <div>
                                <h3 className="title-md" style={{ color: sectionData.heading_color }}>{sectionData.heading}</h3>
                                <div dangerouslySetInnerHTML={{__html:rightContent}} />
                            </div>

                            <div className="title-sm" dangerouslySetInnerHTML={{ __html: sectionData.content }} />
                        </div>
                    </section>
                </div>
            </section>
        );
    }
}

export default ContentSection;


// WEBPACK FOOTER //
// ./src/components/Services/ContentSection.js